import React, { useState, useEffect } from 'react';
import '../App.css';
import axios from 'axios';
import ReactImageZoom from 'react-image-zoom';

const Profile = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL || '/';
    const locationUrl = process.env.REACT_APP_Profile_Location_URL;
    const [profileData, setProfileData] = useState([]);

    useEffect(() => {
        getProfileData();
    }, []);

    const getProfileData = async () => {
        const response = await axios.post(`${baseUrl}Profile/GetProfile`, { PaginationID: "-1" });
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                setProfileData(response.data.data[0]);
            }
        }
    };

    const formatImportExportCode = (code) => {
        if (code === null || code === undefined) {
            return 'No Code';
        }

        const visibleChars = code.substring(0, 5);
        const maskedChars = '*'.repeat(Math.max(0, code.length - 5));

        return `${visibleChars}${maskedChars}`;
    };

    return (
        <>
            <div className="page-header title-area">
                <div className="header-title headerbgimg">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="page-title">Profile</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <nav className="breadcrumb"><span>
                                    <a className="home" href="/Splash" ><span>Home</span></a>
                                </span><i className="fa fa-angle-right" aria-hidden="true"></i>
                                    <span><span>Profile</span></span>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="content" className="site-content slider3">
                <div className="container">
                    {profileData &&
                        <>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="fp-section-title clearfix  ">
                                        <h2 className='font20'>Profile</h2>
                                    </div>
                                    <p className='text-justify'>
                                        {profileData.Description &&
                                            profileData.Description
                                        }
                                    </p>
                                </div>
                            </div>

                            <div className="fp-section-title clearfix mt-20">
                                <h2 className='font20'>Factsheet</h2>
                            </div>

                            <div className="faqacrd margbtm40">
                                <div className="fp-faq active">
                                    <h2>Basic Information<i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i></h2>
                                    <div className="toggle-content">
                                        <div className='shop_cart_table'>
                                            <div className="table-responsive">
                                                <table className="table table-2">
                                                    <tbody>
                                                        <tr>
                                                            <td><span>Nature of Business</span></td>
                                                            <td><span>{profileData.NatureofBusiness &&
                                                                profileData.NatureofBusiness
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Additional Business</span></td>
                                                            <td><span>
                                                                {profileData.AdditionalBusinessDetail &&
                                                                    profileData.AdditionalBusinessDetail.map((item, index) => item.AdditionalBusiness).join(', ')
                                                                }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Company CEO</span></td>
                                                            <td><span>{profileData.CompanyCEO &&
                                                                profileData.CompanyCEO
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span style={{ height: '96px' }}>Registered Address</span></td>
                                                            <td><span style={{ height: '96px' }}>{profileData.RegisteredAddress &&
                                                                profileData.RegisteredAddress
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Total Number of Employees</span></td>
                                                            <td><span>{profileData.NumberofEmployees &&
                                                                profileData.NumberofEmployees
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Year of Establishment</span></td>
                                                            <td><span>{profileData.YearofEstablishment &&
                                                                profileData.YearofEstablishment
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Legal Status of Firm</span></td>
                                                            <td><span>{profileData.LegalStatusofFirm &&
                                                                profileData.LegalStatusofFirm
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Annual Turnover</span></td>
                                                            <td><span>{profileData.AnnualTurnover &&
                                                                profileData.AnnualTurnover
                                                            }</span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="fp-faq">
                                    <h2>Infrastructure<i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i></h2>
                                    <div className="toggle-content">
                                        <div className='shop_cart_table'>
                                            <div className="table-responsive">
                                                <table className="table table-2">
                                                    <tbody>
                                                        <tr>
                                                            <td><span>Location Type</span></td>
                                                            <td><span>{profileData.LocationType &&
                                                                profileData.LocationType
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Building Infrastructure</span></td>
                                                            <td><span>
                                                                {profileData.BuildingInfrastructure &&
                                                                    profileData.BuildingInfrastructure
                                                                }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Size of Premises</span></td>
                                                            <td><span>{profileData.SizeofPremises &&
                                                                profileData.SizeofPremises
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Space Around</span></td>
                                                            <td><span>{profileData.SpaceAround &&
                                                                profileData.SpaceAround
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Location</span></td>
                                                            <td><span>
                                                                {profileData.ImageDetail &&
                                                                    // profileData.ImageDetail.map((item, index) => (
                                                                    //     <ReactImageZoom
                                                                    //         key={index}
                                                                    //         img=`${basePath}${zoomImageName}`,
                                                                    //         zoomImg=`${basePath}${zoomImageName}`,
                                                                    //         zoomScale={3}
                                                                    //         width={200}
                                                                    //     />
                                                                    // ))

                                                                    profileData.ImageDetail.map((item, index) => (
                                                                        <div className="row" key={index}>
                                                                            <div key={index} className='col-md-6' style={{ paddingTop: '10px', position: 'relative', display: 'inline-block' }}>
                                                                                <ReactImageZoom
                                                                                    key={index}
                                                                                    img={`${locationUrl}${item.Image}`}
                                                                                    zoomImg={`${locationUrl}${item.Image}`}
                                                                                    style={{ width: '100% !important' }}
                                                                                    height={250}
                                                                                    zoomScale={3}
                                                                                    // zoomLensStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.7)' }}
                                                                                    shouldRenderZoomOut={true} // Display the zoom-out button
                                                                                    position="original"
                                                                                    className="custom-zoom-image"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }

                                                                {/* {profileData.ImageDetail &&
                                                                    profileData.ImageDetail.map((item, index) => (
                                                                        // debugger;
                                                                        // <ReactImageZoom key={index} img={locationUrl + item.Image} zoomScale={3} className="custom-image-zoom" />
                                                                        // <ReactImageZoom
                                                                        //     key={index}
                                                                        //     img={locationUrl + item.Image}
                                                                        //     zoomScale={3}
                                                                        //     style={{ zIndex: 1000, position: 'relative' }}
                                                                        // />

                                                                        <ReactImageZoom
                                                                            key={index}
                                                                            img={{ src: locationUrl + item.Image }}
                                                                            zoomImg={{ src: locationUrl + item.Image }}
                                                                            zoomScale={3}
                                                                            width={200}
                                                                        />

                                                                        // <Zoom key={index}>
                                                                        //     <img
                                                                                
                                                                        //         alt="That Wanaka Tree, New Zealand by Laura Smetsers"
                                                                        //         src={locationUrl + item.Image}
                                                                        //         width="500"
                                                                        //     />
                                                                        // </Zoom>
                                                                    ))
                                                                } */}
                                                            </span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="fp-faq">
                                    <h2>Company USP<i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i></h2>
                                    <div className="toggle-content">
                                        <div className='shop_cart_table'>
                                            <div className="table-responsive">
                                                <table className="table table-2">
                                                    <tbody>
                                                        <tr>
                                                            <td><span>Primary Competitive Advantage</span></td>
                                                            <td><span> {profileData.PrimaryCompetitiveDetail &&
                                                                profileData.PrimaryCompetitiveDetail.map((item, index) => item.PrimaryCompetitiveAdvantage).join(', ')
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Quality Measures / Testing Facilities</span></td>
                                                            <td><span>{profileData.QualityMeasuresAndTestingFacilities == true ? 'Yes' : 'No'}
                                                            </span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="fp-faq">
                                    <h2>Statutory Profile<i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i></h2>
                                    <div className="toggle-content">
                                        <div className='shop_cart_table'>
                                            <div className="table-responsive">
                                                <table className="table table-2">
                                                    <tbody>
                                                        <tr>
                                                            <td><span>Import Export Code (IEC)</span></td>
                                                            <td><span>{profileData.ImportExportCode &&
                                                                formatImportExportCode(profileData.ImportExportCode)
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Banker</span></td>
                                                            <td><span> {profileData.BankDetail &&
                                                                profileData.BankDetail.map((item, index) => item.BankName).join(', ')
                                                            }</span></td>
                                                        </tr>

                                                        <tr>
                                                            <td><span>GST No.</span></td>
                                                            <td><span>{profileData.GSTNo &&
                                                                profileData.GSTNo
                                                            }</span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="fp-faq">
                                    <h2>Packaging/Payment and Shipment Details<i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i></h2>
                                    <div className="toggle-content">
                                        <div className='shop_cart_table'>
                                            <div className="table-responsive">
                                                <table className="table table-2">
                                                    <tbody>
                                                        <tr>
                                                            <td><span>Customized Packaging</span></td>
                                                            <td><span>{profileData.CustomizedPackaging == true ? 'Yes' : 'No'
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Estimated Time of Delivery</span></td>
                                                            <td><span> {profileData.EstimatedTimeofDelivery &&
                                                                profileData.EstimatedTimeofDelivery
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Payment Terms</span></td>
                                                            <td><span>{profileData.PaymentTermsDetail &&
                                                                profileData.PaymentTermsDetail.map((item, index) => item.PaymentTerms).join(', ')
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Payment Mode</span></td>
                                                            <td><span>{profileData.PaymentModeDetail &&
                                                                profileData.PaymentModeDetail.map((item, index) => item.PaymentMode).join(', ')
                                                            }</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td><span>Shipment Mode</span></td>
                                                            <td><span> {profileData.ShipmentModeDetail &&
                                                                profileData.ShipmentModeDetail.map((item, index) => item.ShipmentMode).join(', ')
                                                            }</span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                </div>
            </div>

            {/* <div className="make-special paralex secpadd70" style={{ backgroundImage: 'url(images/bg/count-parallax.jpg)' }}>
                <div className="container">
                    <div className="col-sm-12 col-md-6 col-lg-3">
                        <h1 className="wmshd">What Makes <br />us<span className="main-color">Special?</span></h1>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-3">
                        <div className="fp-counter  style-1">
                            <div className="counter">
                                <div className="value">800</div>
                                <span>+</span>
                            </div>
                            <h4>Sucessful Projects</h4>
                            <span className="fp-icon"><i className="factory-tool2"></i></span>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-3">
                        <div className="fp-counter  style-1">
                            <div className="counter">
                                <div className="value">100</div>
                                <span>%</span>
                            </div>
                            <h4>Satisfied Clients</h4>
                            <span className="fp-icon"><i className="factory-people"></i></span>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-3">
                        <div className="fp-counter  style-1">
                            <div className="counter">
                                <div className="value">50</div>
                                <span>+</span>
                            </div>
                            <h4>Awards Won</h4>
                            <span className="fp-icon"><i className="factory-tool2"></i></span>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
};

export default Profile;